export default __webpack_public_path__ + "static/missionaryReflection-6eeb6b0d9d1b22da441c3da478ec6ed4.svg";